import type { components } from "../api/generated/generated-api";

export const TOAST_DURATION = 3000;
export const MODAL_SIZE_3_XL = "3xl";
export const MODAL_SIZE_XL = "xl";
export const INTERNAL_EMAIL_DOMAIN = "alvarezandmarsal.com";
export const ALLOWED_LOGO_EXTENSIONS = ["png", "svg", "jpg", "jpeg", "svg+xml"];
export const ALLOWED_BULK_UPLOAD_EXTENSIONS = ["xlsx"];
export const ALLOWED_DIAGRAM_EXTENSIONS = ["png", "svg", "jpg", "jpeg", "svg+xml"];
export const MODAL_SIZING = { base: "full", sm: "lg", md: "xl", lg: "2xl", xl: "3xl" };
export const MODAL_CONTENT_SIZING = { maxWidth: "60vw", maxHeight: "95vh" };
export const DELETE_MODAL_SIZING = { maxWidth: "35vw", maxHeight: "95vh" };
export const ALLOWED_BENCHMARK_EXTENSIONS = ["xlsx"];
export const ALLOWED_JURISDICTION_OVERVIEW_EXTENSIONS = ["docx"];

// Headcount limit
export const MAX_HEADCOUNT = 8000000000;

// Transaction limits
export const MIN_TRANSACTIONS = 1;
export const MAX_TRANSACTIONS = 20;

// Lead MD list
export const LEADMD_LIST = [
    "Panhwar, Shahzeb",
    "Syratt, Richard",
    "Khan, Imran",
    "De Felice, Matthew",
    "Alms, Marc",
    "Trahan, Sean",
    "Peters, Dan",
    "Sharma, Vishal",
    "Whitehouse, Justin",
    "Arman, Pierre",
];

// Region type and constants - TypeScript will error if these don't match the generated Region type
export type Region = components["schemas"]["Region"];
export type ProfitLevelIndicatorMethod = components["schemas"]["ProfitLevelIndicatorMethod"];
export type IqrType = components["schemas"]["IqrType"];

export const REGIONS = ["NorthAndSouthAmerica", "AsiaPacific", "EMEA"] as const satisfies readonly Region[];
export const PROFIT_LEVEL_INDICATOR_METHODS = [
    "OperatingMargin",
    "MarkupOnTotalCosts",
    "GrossMargin",
    "BerryRatio",
] as const satisfies readonly ProfitLevelIndicatorMethod[];
export const IQR_TYPES = ["IRS", "OECD"] as const satisfies readonly IqrType[];

export const REGION_DISPLAY_NAMES: Record<Region, string> = {
    NorthAndSouthAmerica: "North and South America",
    AsiaPacific: "Asia Pacific",
    EMEA: "Europe, Middle East, and Africa",
};

// Reverse mapping: display name -> enum value
export const REGION_VALUE_MAP: Record<string, Region> = {
    "North and South America": "NorthAndSouthAmerica",
    "Asia Pacific": "AsiaPacific",
    "Europe, Middle East, and Africa": "EMEA",
};

export const PLI_DISPLAY_NAMES: Record<ProfitLevelIndicatorMethod, string> = {
    OperatingMargin: "Operating Margin",
    MarkupOnTotalCosts: "Markup on Total Costs",
    GrossMargin: "Gross Margin",
    BerryRatio: "Berry Ratio",
};

export const getRegionLabel = (region: Region): string => REGION_DISPLAY_NAMES[region];

export const getRegionValue = (displayName: string): Region | undefined => REGION_VALUE_MAP[displayName];

export const getProfitLevelIndicatorMethodLabel = (method: ProfitLevelIndicatorMethod): string => PLI_DISPLAY_NAMES[method];

// Continents (deprecated - use REGIONS and REGION_DISPLAY_NAMES instead)
export const CONTINENTS = ["North and South America", "Asia Pacific", "Europe, Middle East, and Africa"];

// Service Types
export const SERVICE_TYPES = [
    "Manufacturing",
    "Distribution",
    "Procurement",
    "Research and Development",
    "Engineering",
    "Sales and Marketing",
    "Management and Administrative Support",
    "Strategic Management",
    "IT Technology",
    "Software Development",
    "Other",
];

// Routes
export const ROUTE_404 = "/404";
